import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";

const Marketing = () => {
  return (
    <div className="main-wrapper">
      <div className="text-center mt-4">
        <ImageWithBasePath
          src="assets/images/logo.png"
          alt="iKidz"
           width={150}
          // height={200}
          className="img-fluid"
        />
      </div>

      <div className="container my-4">
        <div className="card shadow-sm">
          <div className="card-body p-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <h3 className="mb-0">Marketing</h3>
              <Link to={all_routes.login} className="btn btn-outline-primary btn-sm">
                Back to Login
              </Link>
            </div>

            <p className="text-muted">
              This page explains how iKidz may send marketing communications and
              how you can manage your preferences.
            </p>

            <h6 className="mt-4">What you may receive</h6>
            <ul className="text-muted">
              <li>Product updates and new feature announcements</li>
              <li>Tips, guides, and best practices</li>
              <li>Occasional promotional offers (if enabled)</li>
            </ul>

            <h6 className="mt-4">Opt out</h6>
            <p className="text-muted">
              You can opt out of marketing emails at any time using the
              unsubscribe link in the email, or by contacting support.
            </p>

            <h6 className="mt-4">Service messages</h6>
            <p className="text-muted mb-0">
              We may still send non-marketing messages that are necessary to
              operate the service (e.g., password resets, security notices).
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Marketing;

